import React, { useEffect } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    Box,
    // Lorem,
    ModalFooter,
    ModalBody,
    Button,
    useDisclosure,
    FormControl,
    FormLabel,
   
    Text,
    Input,
    ModalCloseButton,
    Flex,
  } from '@chakra-ui/react'

  import { useNavigate } from "react-router-dom";
  export const Fundraiser_3 = () => {
  const[check,setcheck]=React.useState(false)
  function handle(e){
    setcheck(true)
  }

    // function BasicUsage() {
        const { isOpen, onOpen, onClose } = useDisclosure()
  useEffect(() => {
    onOpen();
  }, []);
  const navigate=useNavigate();

const handleClose=()=>{
  navigate("/",{replace:true});
    }
    const handleNext = () => {
      navigate("/",{replace:true})
    }
        return (
          <>
            {/* <Button onClick={onOpen}>Open Modal</Button> */}
      
            <Modal blockScrollOnMount={false} isOpen={isOpen} onClose={onClose}>
              <ModalOverlay />
              <ModalContent>
                <ModalHeader style={{fontSize:'small', fontWeight:'bold'}}>Tell the story about why you are running a Fundraiser</ModalHeader>
                <ModalCloseButton onClick={handleClose} />
                <ModalBody>
                    
                  <Text style={{backgroundColor:'lightgray',color:'black'}}  mb='1rem'>
                    Hi,<br/>
                    My name is Rishi i am raising fund for my grandmother , she is suffering from papilary serious adenocarcinoma.The family has done all it can to collect the total amount required for the treatement but Rs 2000 more is required to pay for all the medical expences.<br/><br/>
                    As the amount required is huge , i request you to kindly contibrute towords the treatement and help during this time of need.Each contribution is important!<br/><br/>
                    Please help us raise this amount by clicking on the donate button and sharing this page with yout friends and family.<br/><br/>
                    we are grateful for your help and wishes.<br/><br/>
                    Thank You.
                  
                  </Text>
                  {/* <Lorem count={2} /> */}
                
                </ModalBody>
      
                <ModalFooter>
                 


                  {/* <Button variant='ghost'>Secondary Action</Button> */}
                </ModalFooter>
                <Flex style={{gap:'2px'}}>
                <input onChange={handle} type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
                <Box style={{fontSize:'0.8rem'}}> I agree to Ketto's <span style={{color:'rgb(1,191,189)'}}>Terms of use</span>,service agreement (<span style={{color:'rgb(1,191,189)'}}>USA</span>and<span style={{color:'rgb(1,191,189)'}}>India</span>).<span style={{color:'rgb(1,191,189)'}}>Privacy Policy</span>and <span style={{color:'rgb(1,191,189)'}}>Plans & Pricing</span>.I acknowledge and confirm that the information provided above is true and correct to the best of my knowledge and belief and i agree to be liable if any of the above information is found to be false or misleading ,I hereby give my consent for sharing it with regularity authorities or disclosing it as may be required by law."</Box>
                </Flex>
                <Button disabled={check==false} style={{width:'100%',background:'rgb(1,191,189)'}} colorScheme='rgb(1,191,189)'  onClick={handleNext}>
                    Submit
                  </Button>
              </ModalContent>
            </Modal>
          </>
        )
      }
 

